/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./payloadTest.vue?vue&type=template&id=148cbae2&scoped=true"
import script from "./payloadTest.vue?vue&type=script&lang=js"
export * from "./payloadTest.vue?vue&type=script&lang=js"
import style0 from "./payloadTest.vue?vue&type=style&index=0&id=148cbae2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148cbae2",
  null
  
)

export default component.exports